import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '../../../../core/pipes/translate.pipe';

@Component({
  selector: 'app-project-header',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  template: `
    <div
      class="surface-card rounded-3xl p-6 md:p-8 antialiased relative overflow-hidden"
    >
      <div class="absolute -top-20 -right-20 w-40 h-40 bg-primary/10 rounded-full blur-3xl pointer-events-none"></div>

      <div
        class="flex flex-col sm:flex-row sm:items-start gap-5 mb-5 pb-5 border-b border-border-subtle relative z-10"
      >
        <div
          class="w-12 h-12 bg-surface-elevated rounded-2xl flex items-center justify-center text-primary border border-border-strong shadow-inner shrink-0"
        >
          <i class="fa-solid fa-hotel text-sm"></i>
        </div>

        <div class="flex-1 space-y-2">
          <h1 class="text-xl md:text-2xl font-black text-text-primary tracking-tight leading-none">
            {{ projectName || ('projectsDetails.projectShowcase' | translate) }}
          </h1>

          <div class="flex flex-wrap items-center gap-x-4 gap-y-2 text-xs font-semibold">
            <div
              class="flex items-center gap-1.5 px-2.5 py-1 bg-surface-elevated border border-border rounded-lg text-text-secondary"
            >
              <i class="fa-solid fa-signature text-[10px] text-text-muted"></i>
              <span class="tracking-tight">{{ developer || ('projectsDetails.premiumDeveloper' | translate) }}</span>
            </div>

            <div
              class="flex items-center gap-1.5 text-text-muted hover:text-text-primary transition-colors cursor-pointer group"
            >
              <i
                class="fa-solid fa-map-pin text-[11px] text-primary group-hover:animate-bounce"
              ></i>
              <span class="font-medium tracking-tight">{{ location }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="relative z-10">
        <p
          class="text-xs md:text-sm font-medium text-text-secondary leading-relaxed max-w-4xl tracking-tight select-text"
        >
          {{ description }}
        </p>
      </div>
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
})
export class ProjectHeaderComponent {
  @Input() projectName: string = '';
  @Input() developer: string = '';
  @Input() location: string = '';
  @Input() description: string = '';
}
